<template>
    <label class="input-label">
        <slot></slot>
    </label>
</template>
<script>
    export default {
        name: 'InputLabel'
    }
</script>

<style lang="scss" scoped>
    .input-label {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 19px;
        color: #333333;
    }
</style>